import { type Attrs, type DOMOutputSpec, type Node, type NodeSpec } from "prosemirror-model";

import {
	CELL_SPEC_ATTRS,
	DEFAULT_CELL_ID,
	makeTextCellDefaultToDOMAttrs,
} from "@moment/prosemirror-utils";

// :: NodeSpec A pull request node that represents a GitHub PR link
// with attributes for the URL, owner, repo, and PR number

export const pull_request: NodeSpec = {
	attrs: {
		...CELL_SPEC_ATTRS,
		url: { default: "" },
		owner: { default: "" },
		repo: { default: "" },
		prNumber: { default: 0 },
	},
	group: "inline",
	inline: true,
	parseDOM: [
		{
			tag: "a[data-pull-request]",
			getAttrs(node: string | HTMLElement) {
				if (typeof node === "string") {
					return {};
				}

				const url = node.getAttribute("href") || node.getAttribute("data-url") || "";
				const owner = node.getAttribute("data-owner") || "";
				const repo = node.getAttribute("data-repo") || "";
				const prNumber = parseInt(node.getAttribute("data-pr-number") || "0", 10);
				const id =
					node.getAttribute("id") ||
					node.getAttribute("data-text-cell") ||
					DEFAULT_CELL_ID;

				const attrs: Attrs = {
					url,
					owner,
					repo,
					prNumber,
					id,
				};

				return attrs;
			},
		},
		{
			tag: "span[data-pull-request]",
			getAttrs(node: string | HTMLElement) {
				if (typeof node === "string") {
					return {};
				}

				const url = node.getAttribute("data-url") || "";
				const owner = node.getAttribute("data-owner") || "";
				const repo = node.getAttribute("data-repo") || "";
				const prNumber = parseInt(node.getAttribute("data-pr-number") || "0", 10);
				const id = node.getAttribute("id") || DEFAULT_CELL_ID;

				const attrs: Attrs = {
					url,
					owner,
					repo,
					prNumber,
					id,
				};

				return attrs;
			},
		},
	],
	toDOM(node: Node) {
		const attrs: Attrs = {
			...makeTextCellDefaultToDOMAttrs(node),
			"data-pull-request": "true",
			"data-url": node.attrs["url"],
			"data-owner": node.attrs["owner"],
			"data-repo": node.attrs["repo"],
			"data-pr-number": node.attrs["prNumber"],
		};

		const dom: DOMOutputSpec = ["span", attrs];

		return dom;
	},
};
